import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	routes: [
		//首页
		{
			path: '/',
			name: '/',
			component: () => import("@/pages/Home/HomeIndex.vue"),
		},
		//新闻动态
		{
			path: '/journa',
			name: '/journa',
			component: () => import("@/pages/Home/journaIndex.vue"),
		},
		//评价申请
		{
			path: '/appraise',
			name: '/appraise',
			component: () => import("@/pages/Home/appraiseIndex.vue"),
		},
		//政策法规 
		{
			path: '/policy',
			name: '/policy',
			component: () => import("@/pages/Home/policyIndex.vue"),
		},
		// 政策法规详情
		{
			path: '/policyDetails',
			name: '/policyDetails',
			component: () => import("@/pages/Home/policyDetails.vue"),
		},
		// 证书公布
		{
			path: '/publish',
			name: '/publish',
			component: () => import("@/pages/Home/publishIndex.vue"),
		},
		// 证书详情
		{
			path: '/certificate',
			name: '/certificate',
			component: () => import("@/pages/Home/certificateDetails.vue"),
		},
		// 咨询建议
		{
			path: '/refer',
			name: '/refer',
			component: () => import("@/pages/Home/referIndex.vue"),
		},
		// 合作伙伴
		{
			path: '/detection',
			name: '/detection',
			component: () => import("@/pages/Home/detectionIndex.vue"),
		},
		// 合作伙伴详情
		{
			path: '/monitor',
			name: '/monitor',
			component: () => import("@/pages/Home/monitorDetails.vue"),
		},
		// 新闻详情
		{
			path: '/new',
			name: '/new',
			component: () => import("@/pages/Home/newDetails.vue"),
		},
		//关于我们
		{
			path: '/my',
			name: '/my',
			component: () => import("@/pages/Home/myIndex.vue"),
		},
		//填报说明
		{
			path: '/explain',
			name: '/explain',
			component: () => import("@/pages/Home/explainIndex.vue"),
		},
		//企业信息
		{
			path: '/firm',
			name: '/firm',
			component: () => import("@/pages/Home/firmIndex.vue"),
		},
		//评价申请
		{
			path: '/fill',
			name: '/fill',
			component: () => import("@/pages/Home/fillIndex.vue"),
		},
		//评价申请中心
		{
			path: '/centre',
			name: '/centre',
			component: () => import("@/pages/Home/centreIndex.vue"),
		},
		//证书下载
		{
			path: '/load',
			name: '/load',
			component: () => import("@/pages/Home/loadIndex.vue"),
		},
		//申请进度
		{
			path: '/plan',
			name: '/plan',
			component: () => import("@/pages/Home/planIndex.vue"),
		},




		// 登录
		{
			path: '/login',
			name: '/login',
			component: () => import("@/pages/Login/loginIndex.vue"),
		},
		// 注册
		{
			path: '/register',
			name: '/register',
			component: () => import("@/pages/Login/registerIndex.vue"),
		},
		// 找回密码
		{
			path: '/back',
			name: '/back',
			component: () => import("@/pages/Login/backIndex.vue"),
		},
	]
})



export default router;